var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#F5F7FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2367 15.0002C17.2367 16.2377 16.2367 17.2377 14.9992 17.2377C13.7617 17.2377 12.7617 16.2377 12.7617 15.0002C12.7617 13.7627 13.7617 12.7627 14.9992 12.7627C16.2367 12.7627 17.2367 13.7627 17.2367 15.0002Z",
    stroke: "#02A702",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0004 20.1689C17.2066 20.1689 19.2629 18.8689 20.6941 16.6189C21.2566 15.7377 21.2566 14.2564 20.6941 13.3752C19.2629 11.1252 17.2066 9.8252 15.0004 9.8252C12.7941 9.8252 10.7379 11.1252 9.30664 13.3752C8.74414 14.2564 8.74414 15.7377 9.30664 16.6189C10.7379 18.8689 12.7941 20.1689 15.0004 20.1689Z",
    stroke: "#02A702",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.59b238ddb0ffd49581802d120d9efd29.svg";
export { ForwardRef as ReactComponent };